import React, { useState } from 'react';
import { AlertCircleIcon, CheckCircleIcon } from 'lucide-react';
export const TokenConfirmation = ({
  onConfirm,
  onCancel
}) => {
  const [token, setToken] = useState('');
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const handleSubmit = () => {
    if (!token) {
      setError('Por favor ingrese el código de verificación');
      return;
    }
    if (token.length !== 6 || !/^\d+$/.test(token)) {
      setError('El código debe tener 6 dígitos');
      return;
    }
    // Simulating token verification
    if (token === '123456') {
      setError(null);
      setSuccess(true);
      setTimeout(() => {
        onConfirm();
      }, 1500);
    } else {
      setError('Código de verificación incorrecto');
    }
  };
  return <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 max-w-md mx-auto" data-id="element-1129">
      <div className="text-center mb-6" data-id="element-1130">
        <h2 className="text-xl font-bold text-gray-900 mb-2" data-id="element-1131">Verificación</h2>
        <p className="text-gray-600" data-id="element-1132">
          Hemos enviado un código de 6 dígitos al correo electrónico del
          cliente. Por favor ingrese el código para confirmar la negociación.
        </p>
      </div>
      <div className="mb-6" data-id="element-1133">
        <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1134">
          Código de Verificación
        </label>
        <input type="text" value={token} onChange={e => {
        setToken(e.target.value);
        setError(null);
      }} maxLength={6} className="w-full px-4 py-3 text-center text-2xl tracking-widest border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500" placeholder="------" data-id="element-1135" />
        <p className="mt-2 text-xs text-gray-500 text-center" data-id="element-1136">
          El código expira en 10 minutos
        </p>
      </div>
      {error && <div className="mb-6 bg-red-50 border border-red-200 rounded-lg p-4 flex items-start" data-id="element-1137">
          <AlertCircleIcon className="h-5 w-5 text-red-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-1138" />
          <p className="text-sm text-red-600" data-id="element-1139">{error}</p>
        </div>}
      {success && <div className="mb-6 bg-green-50 border border-green-200 rounded-lg p-4 flex items-start" data-id="element-1140">
          <CheckCircleIcon className="h-5 w-5 text-green-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-1141" />
          <p className="text-sm text-green-600" data-id="element-1142">
            Código verificado correctamente
          </p>
        </div>}
      <div className="flex justify-end space-x-4" data-id="element-1143">
        <button onClick={onCancel} className="px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-1144">
          Cancelar
        </button>
        <button onClick={handleSubmit} className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 text-sm font-medium" data-id="element-1145">
          Verificar
        </button>
      </div>
    </div>;
};